import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';

const LegalPage = ({ title, icon: Icon, children }) => (
  <div className="min-h-screen bg-gray-950 pt-24 pb-16 px-4">
    <div className="max-w-3xl mx-auto">
      <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-12">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
          <Icon size={14} className="text-primary-400" />
          <span className="text-sm text-primary-300">Legal</span>
        </div>
        <h1 className="text-4xl font-bold text-white mb-4">{title}</h1>
        <p className="text-gray-500 text-sm">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
      </motion.div>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }}
        className="bg-gray-900/50 border border-gray-800/60 rounded-2xl p-8 prose prose-invert prose-sm max-w-none">
        {children}
      </motion.div>
    </div>
  </div>
);

const PrivacyPolicy = () => (
  <LegalPage title="Privacy Policy" icon={Shield}>
    <h2>1. Information We Collect</h2>
    <p>When you use Advance Advert Tv Digital, we collect information you provide directly:</p>
    <ul>
      <li><strong>Account Information:</strong> Email address, desired country, and username for creating your foreign TikTok account.</li>
      <li><strong>Payment Information:</strong> Payment transactions are processed through Flutterwave. We do not store your credit card details.</li>
      <li><strong>Usage Data:</strong> Pages visited, browser type, device information, and referral sources for analytics purposes.</li>
    </ul>

    <h2>2. How We Use Your Information</h2>
    <ul>
      <li>To create and deliver your foreign TikTok account</li>
      <li>To process payments and send confirmations</li>
      <li>To provide customer support</li>
      <li>To improve our services and user experience</li>
      <li>To send order updates and status notifications</li>
    </ul>

    <h2>3. Data Sharing</h2>
    <p>We do not sell or rent your personal information to third parties. We may share data with:</p>
    <ul>
      <li><strong>Flutterwave:</strong> For payment processing</li>
      <li><strong>Analytics Providers:</strong> Anonymized usage data to improve our service</li>
    </ul>

    <h2>4. Data Security</h2>
    <p>We implement industry-standard security measures to protect your data, including encryption, secure servers, and regular security audits.</p>

    <h2>5. Your Rights</h2>
    <p>You have the right to:</p>
    <ul>
      <li>Access your personal data</li>
      <li>Request correction of inaccurate data</li>
      <li>Request deletion of your data</li>
      <li>Opt-out of marketing communications</li>
    </ul>

    <h2>6. Contact Us</h2>
    <p>For privacy-related inquiries, contact us at contact@advanceadverttvdigital.com.</p>
  </LegalPage>
);

export default PrivacyPolicy;
